<template>
    <div :class="mapClasses">
        <div class="w-full h-full relative">
            <button
                @click="toggleLargeMap()"
                class="absolute top-3 right-3 bg-white w-10 h-10 shadow-sm p-2 z-10 border border-slate-200 rounded ease-in-out transition-all hover:transition-all duration-1000 delay-100 text-black hover:border-slate-300 hover:bg-slate-200 active:border-slate-300 active:bg-slate-200 focus:outline-none focus:border-2"
            >
                <Icon icon="enlarge-arrows" />
            </button>
            <div id="map-sm" class="w-full h-full rounded-lg"></div>
            <Teleport to="body">
                <div
                    class="fixed inset-2 z-[99999] rounded-lg"
                    v-show="showLargeMap"
                >
                    <button
                        @click="toggleLargeMap()"
                        class="absolute top-4 right-4 bg-white w-10 h-10 shadow-sm p-2 z-10 border border-slate-200 rounded ease-in-out transition-all hover:transition-all duration-1000 delay-100 text-black hover:border-slate-300 hover:bg-slate-200 active:border-slate-300 active:bg-slate-200 focus:outline-none focus:border-2"
                    >
                        <Icon icon="close" />
                    </button>
                    <div id="map-lg" class="w-full h-full rounded-lg"></div>
                </div>
            </Teleport>
        </div>
    </div>
</template>
<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import { computed, ref, onMounted } from 'vue';

const props = defineProps({
    latitude: {
        type: [Number, String],
        default: 0,
    },
    longitude: {
        type: [Number, String],
        default: 0,
    },
    classes: {
        type: String,
        default: 'h-30',
    },
});

const configSm = computed(() => {
    return {
        center: mapCenter.value,
        zoom: 10,
        mapId: '4504f8b373AF365c3d0',
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: false,
    };
});

const configLg = computed(() => {
    return {
        center: mapCenter.value,
        zoom: 10,
        mapId: '4504f8b373AF365c3d0',
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: false,
    };
});

const mapCenter = computed(() => {
    return {
        lat: parseFloat(props.latitude),
        lng: parseFloat(props.longitude),
    };
});

const mapIcon = computed(() => {
    const iconImage = document.createElement('div');

    iconImage.className = 'relative';

    iconImage.innerHTML = `<svg
    width="36"
    height="42"
    viewBox="0 0 36 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
><g id="vector" filter="url(#filter0_d_4050_14935)"><path
            d="M7.3934 6.3934C1.53553 12.2513 1.53553 21.7487 7.3934 27.6066C9.00845 29.2217 10.9033 30.3932 12.9233 31.1182L16.7478 36.9177C17.0228 37.3347 17.4874 37.5875 17.9869 37.5918C18.4865 37.5962 18.9554 37.3516 19.2376 36.9394L23.2732 31.0461C25.2196 30.3165 27.0441 29.1691 28.6066 27.6066C34.4645 21.7487 34.4645 12.2513 28.6066 6.3934C22.7487 0.535535 13.2513 0.535533 7.3934 6.3934Z"
            fill="white"
        /><path
            d="M7.3934 6.3934C1.53553 12.2513 1.53553 21.7487 7.3934 27.6066C9.00845 29.2217 10.9033 30.3932 12.9233 31.1182L16.7478 36.9177C17.0228 37.3347 17.4874 37.5875 17.9869 37.5918C18.4865 37.5962 18.9554 37.3516 19.2376 36.9394L23.2732 31.0461C25.2196 30.3165 27.0441 29.1691 28.6066 27.6066C34.4645 21.7487 34.4645 12.2513 28.6066 6.3934C22.7487 0.535535 13.2513 0.535533 7.3934 6.3934Z"
            stroke="#E2E8F0"
            stroke-linecap="round"
            stroke-linejoin="round"
        /></g><defs><filter
            id="filter0_d_4050_14935"
            x="0.5"
            y="0.5"
            width="35"
            height="40.5918"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
        ><feFlood flood-opacity="0" result="BackgroundImageFix" /><feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
            /><feOffset dy="1" /><feGaussianBlur stdDeviation="1" /><feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
            /><feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_4050_14935"/><feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_4050_14935"
                result="shape"/></filter></defs></svg><svg class="absolute inset-0 mx-auto mt-1.5" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.2487 17.4554V5.78874C4.2487 4.86826 4.99489 4.12207 5.91536 4.12207H14.2487C15.1692 4.12207 15.9154 4.86826 15.9154 5.78874V17.4554M4.2487 17.4554H15.9154M4.2487 17.4554H2.58203M15.9154 17.4554H17.582M7.58203 7.4554H8.41536M11.7487 7.4554H12.582M7.58203 10.7887H8.41536M11.7487 10.7887H12.582M7.58203 14.1221H8.41536M11.7487 14.1221H12.582" stroke="#1E293B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

    return iconImage;
});

const initMapSm = async () => {
    const { Map } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
    const map = new Map(document.getElementById('map-sm'), configSm.value);

    new AdvancedMarkerElement({
        map,
        position: mapCenter.value,
        content: mapIcon.value,
    });
};

const initMapLg = async () => {
    const { Map } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
    const map = new Map(document.getElementById('map-lg'), configLg.value);

    new AdvancedMarkerElement({
        map,
        position: mapCenter.value,
        content: mapIcon.value,
    });
};

const showLargeMap = ref(false);

const mapClasses = computed(() => {
    return props.classes + ' relative w-full';
});

const toggleLargeMap = () => {
    showLargeMap.value = !showLargeMap.value;
    if (showLargeMap.value) {
        initMapLg();
    }
};

onMounted(() => {
    initMapSm();
});
</script>
